var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechFigure2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 272,
    viewBox: "0 0 88 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 53.2846V0.419434L11.9842 9.46476V44.2392L11.9521 44.2633L0 53.2846ZM0.160594 0.741391V52.9626L11.8236 44.1593V9.5447L0.160594 0.741391Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90915 2.65479H2.74854V51.0486H2.90915V2.65479Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25569 4.42627H5.09509V49.278H5.25569V4.42627Z",
    fill: "#1F1F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28196 5.95508H7.12134V47.7481H7.28196V5.95508Z",
    fill: "#1F1F1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04957 7.28955H8.88898V46.4143H9.04957V7.28955Z",
    fill: "#1F1F1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.605 8.46338H10.4444V45.24H10.605V8.46338Z",
    fill: "#1F1F1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8581 40.971L0.0412598 48.2837L0.125851 48.4204L11.9427 41.1077L11.8581 40.971Z",
    fill: "#1F1F1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.115046 43.6426L0.0453491 43.498L11.869 37.8188L11.9387 37.9634L0.115046 43.6426Z",
    fill: "#1F1F1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.106086 38.8693L0.0543823 38.7177L11.878 34.6611L11.9297 34.8127L0.106086 38.8693Z",
    fill: "#1F1F1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0963278 34.0952L0.064209 33.9381L11.8878 31.5044L11.92 31.6615L0.0963278 34.0952Z",
    fill: "#1F1F1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8984 28.3487L0.074707 29.1597L0.0856957 29.3199L11.9094 28.509L11.8984 28.3487Z",
    fill: "#1F1F1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0856972 24.3838L0.074707 24.5439L11.8983 25.3551L11.9093 25.1949L0.0856972 24.3838Z",
    fill: "#1F1F1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8878 22.1993L0.064209 19.7655L0.0963278 19.6084L11.92 22.0422L11.8878 22.1993Z",
    fill: "#1F1F1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.878 19.0426L0.0543823 14.9861L0.106086 14.8345L11.9297 18.891L11.878 19.0426Z",
    fill: "#1F1F1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.869 15.8852L0.0453491 10.2061L0.115046 10.0615L11.9387 15.7407L11.869 15.8852Z",
    fill: "#1F1F1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.122435 5.28851L0.0379639 5.42529L11.8616 12.727L11.9461 12.5902L0.122435 5.28851Z",
    fill: "#1F1F1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6035 53.3189V0.384766L16.741 0.523824L25.569 9.47165V44.232L25.5459 44.2555L16.6035 53.3189ZM16.7641 0.775711V52.9279L25.4084 44.1662V9.53747L16.7641 0.775711Z",
    fill: "#1F1F1F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.811 2.65479H18.6505V51.0486H18.811V2.65479Z",
    fill: "#1F1F1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5584 4.42578H20.3978V49.2775H20.5584V4.42578Z",
    fill: "#1F1F1F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0671 5.95508H21.9066V47.7481H22.0671V5.95508Z",
    fill: "#1F1F1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3837 7.28955H23.2231V46.4143H23.3837V7.28955Z",
    fill: "#1F1F1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5419 8.46338H24.3813V45.24H24.5419V8.46338Z",
    fill: "#1F1F1F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7352 48.4085L16.6326 48.2851L25.4374 40.9834L25.54 41.1068L16.7352 48.4085Z",
    fill: "#1F1F1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4447 37.8228L16.6408 43.5034L16.7278 43.6382L25.5317 37.9576L25.4447 37.8228Z",
    fill: "#1F1F1F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7176 38.8664L16.6502 38.7206L25.4551 34.6641L25.5225 34.8098L16.7176 38.8664Z",
    fill: "#1F1F1F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7054 34.0939L16.6623 33.9392L25.4672 31.5054L25.5103 31.6601L16.7054 34.0939Z",
    fill: "#1F1F1F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4808 28.3449L16.6768 29.1646L16.6916 29.3244L25.4957 28.5047L25.4808 28.3449Z",
    fill: "#1F1F1F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6911 24.3836L16.6764 24.5435L25.4812 25.3546L25.496 25.1948L16.6911 24.3836Z",
    fill: "#1F1F1F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4672 22.1979L16.6623 19.7641L16.7054 19.6094L25.5103 22.0432L25.4672 22.1979Z",
    fill: "#1F1F1F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4551 19.0397L16.6502 14.9831L16.7176 14.8374L25.5225 18.8939L25.4551 19.0397Z",
    fill: "#1F1F1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7272 10.0659L16.6403 10.2007L25.4452 15.8798L25.5321 15.7451L16.7272 10.0659Z",
    fill: "#1F1F1F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4374 12.72L16.6326 5.4183L16.7352 5.29492L25.54 12.5967L25.4374 12.72Z",
    fill: "#1F1F1F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8109 53.4104V0.292969L35.38 9.48209V44.2213L35.3682 44.2405L29.8109 53.4104ZM29.9714 0.867214V52.8361L35.2193 44.1766V9.52673L29.9714 0.867214Z",
    fill: "#1F1F1F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2289 2.65479H31.0684V51.0486H31.2289V2.65479Z",
    fill: "#1F1F1F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3021 4.42578H32.1415V49.2775H32.3021V4.42578Z",
    fill: "#1F1F1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2293 5.95508H33.0687V47.7481H33.2293V5.95508Z",
    fill: "#1F1F1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0377 7.28955H33.8771V46.4143H34.0377V7.28955Z",
    fill: "#1F1F1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7494 8.46338H34.5888V45.24H34.7494V8.46338Z",
    fill: "#1F1F1F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2319 40.9948L29.8298 48.3013L29.959 48.3968L35.3612 41.0904L35.2319 40.9948Z",
    fill: "#1F1F1F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2422 37.8361L29.8331 43.5146L29.949 43.6251L35.3582 37.9466L35.2422 37.8361Z",
    fill: "#1F1F1F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2513 34.6722L29.8433 38.7295L29.9397 38.858L35.3477 34.8007L35.2513 34.6722Z",
    fill: "#1F1F1F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2676 31.511L29.8578 33.9419L29.9236 34.0884L35.3334 31.6575L35.2676 31.511Z",
    fill: "#1F1F1F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29.903 29.319L29.8795 29.1603L35.288 28.3491L35.3115 28.5078L29.903 29.319Z",
    fill: "#1F1F1F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35.288 25.3541L29.8795 24.5429L29.903 24.3843L35.3115 25.1955L35.288 25.3541Z",
    fill: "#1F1F1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9243 19.6138L29.8584 19.7603L35.2669 22.194L35.3328 22.0476L29.9243 19.6138Z",
    fill: "#1F1F1F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9395 14.8461L29.8431 14.9746L35.2516 19.0311L35.348 18.9026L29.9395 14.8461Z",
    fill: "#1F1F1F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9492 10.078L29.8333 10.1885L35.2417 15.8676L35.3577 15.7572L29.9492 10.078Z",
    fill: "#1F1F1F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9559 5.3091L29.8267 5.40479L35.2352 12.7065L35.3644 12.6108L29.9559 5.3091Z",
    fill: "#1F1F1F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3705 53.7037V0L42.0466 9.50458L42.0435 44.2209L39.3705 53.7037ZM39.5311 1.16056V52.5432L41.886 44.188V9.51577L39.5311 1.16056Z",
    fill: "#1F1F1F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M40.116 2.65479H39.9554V51.0486H40.116V2.65479Z",
    fill: "#1F1F1F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M40.615 4.42627H40.4544V49.278H40.615V4.42627Z",
    fill: "#1F1F1F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0463 5.95508H40.8857V47.7481H41.0463V5.95508Z",
    fill: "#1F1F1F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4224 7.28955H41.2618V46.4143H41.4224V7.28955Z",
    fill: "#1F1F1F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7533 8.46338H41.5927V45.24H41.7533V8.46338Z",
    fill: "#1F1F1F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M39.527 48.3729L39.375 48.3208L41.8904 41.019L42.0424 41.0711L39.527 48.3729Z",
    fill: "#1F1F1F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8954 37.8594L39.3755 43.5366L39.522 43.6016L42.0418 37.9244L41.8954 37.8594Z",
    fill: "#1F1F1F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8995 34.695L39.3815 38.75L39.5178 38.8346L42.0358 34.7796L41.8995 34.695Z",
    fill: "#1F1F1F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9119 31.5264L39.3943 33.958L39.5056 34.0732L42.0231 31.6416L41.9119 31.5264Z",
    fill: "#1F1F1F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9416 28.3519L39.4265 29.1641L39.4758 29.3168L41.9909 28.5046L41.9416 28.3519Z",
    fill: "#1F1F1F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4756 24.3868L39.4263 24.5396L41.9418 25.3508L41.9911 25.198L39.4756 24.3868Z",
    fill: "#1F1F1F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5067 19.6291L39.3953 19.7441L41.9108 22.1779L42.0221 22.0629L39.5067 19.6291Z",
    fill: "#1F1F1F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5191 14.8676L39.3828 14.9521L41.8983 19.0087L42.0346 18.9242L39.5191 14.8676Z",
    fill: "#1F1F1F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5242 10.1006L39.3777 10.1655L41.8931 15.8447L42.0397 15.7798L39.5242 10.1006Z",
    fill: "#1F1F1F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8904 12.6849L39.375 5.38316L39.527 5.33105L42.0424 12.6328L41.8904 12.6849Z",
    fill: "#1F1F1F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53.2846L76.0157 44.2392V9.46476L76.0479 9.4407L88 0.419434V53.2846ZM76.1763 44.1593L87.8394 52.9626V0.741391L76.1763 9.5447V44.1593Z",
    fill: "#1F1F1F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M85.251 2.65479H85.0905V51.0486H85.251V2.65479Z",
    fill: "#1F1F1F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9048 4.42627H82.7442V49.278H82.9048V4.42627Z",
    fill: "#1F1F1F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8786 5.95508H80.718V47.7481H80.8786V5.95508Z",
    fill: "#1F1F1F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1108 7.28955H78.9502V46.4143H79.1108V7.28955Z",
    fill: "#1F1F1F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5554 8.46338H77.3948V45.24H77.5554V8.46338Z",
    fill: "#1F1F1F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8731 5.28146L76.0578 12.5967L76.1424 12.7334L87.9577 5.41816L87.8731 5.28146Z",
    fill: "#1F1F1F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1307 15.8852L76.061 15.7407L87.8846 10.0615L87.9544 10.2061L76.1307 15.8852Z",
    fill: "#1F1F1F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1218 19.0426L76.0701 18.891L87.8938 14.8345L87.9455 14.9861L76.1218 19.0426Z",
    fill: "#1F1F1F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1121 22.1993L76.08 22.0422L87.9036 19.6084L87.9357 19.7655L76.1121 22.1993Z",
    fill: "#1F1F1F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9141 24.3838L76.0905 25.1943L76.1014 25.3545L87.9251 24.544L87.9141 24.3838Z",
    fill: "#1F1F1F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1014 28.3486L76.0905 28.5088L87.9141 29.32L87.9251 29.1598L76.1014 28.3486Z",
    fill: "#1F1F1F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9036 34.0952L76.08 31.6615L76.1121 31.5044L87.9357 33.9381L87.9036 34.0952Z",
    fill: "#1F1F1F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8938 38.8693L76.0701 34.8127L76.1218 34.6611L87.9455 38.7177L87.8938 38.8693Z",
    fill: "#1F1F1F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8846 43.6426L76.061 37.9634L76.1307 37.8188L87.9544 43.498L87.8846 43.6426Z",
    fill: "#1F1F1F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1382 40.9765L76.0537 41.1133L87.8774 48.415L87.9618 48.2782L76.1382 40.9765Z",
    fill: "#1F1F1F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3964 53.3189L71.2589 53.1798L62.431 44.232V9.47165L62.4541 9.44814L71.3964 0.384766V53.3189ZM62.5916 44.1662L71.2358 52.9279V0.775711L62.5916 9.53747V44.1662Z",
    fill: "#1F1F1F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3495 2.65479H69.1889V51.0486H69.3495V2.65479Z",
    fill: "#1F1F1F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M67.602 4.42578H67.4415V49.2775H67.602V4.42578Z",
    fill: "#1F1F1F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0933 5.95508H65.9327V47.7481H66.0933V5.95508Z",
    fill: "#1F1F1F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M64.777 7.28955H64.6163V46.4143H64.777V7.28955Z",
    fill: "#1F1F1F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6186 8.46338H63.458V45.24H63.6186V8.46338Z",
    fill: "#1F1F1F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5626 12.72L62.46 12.5967L71.2648 5.29492L71.3674 5.4183L62.5626 12.72Z",
    fill: "#1F1F1F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M71.272 10.0652L62.4683 15.7461L62.5553 15.8808L71.3589 10.1999L71.272 10.0652Z",
    fill: "#1F1F1F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5449 19.0397L62.4776 18.8939L71.2824 14.8374L71.3498 14.9831L62.5449 19.0397Z",
    fill: "#1F1F1F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5328 22.1979L62.4897 22.0432L71.2945 19.6094L71.3376 19.7641L62.5328 22.1979Z",
    fill: "#1F1F1F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3084 24.3793L62.5043 25.1987L62.5191 25.3585L71.3233 24.5391L71.3084 24.3793Z",
    fill: "#1F1F1F"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5187 28.349L62.504 28.5088L71.3088 29.32L71.3236 29.1602L62.5187 28.349Z",
    fill: "#1F1F1F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2945 34.0939L62.4897 31.6601L62.5328 31.5054L71.3376 33.9392L71.2945 34.0939Z",
    fill: "#1F1F1F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2824 38.8664L62.4776 34.8098L62.5449 34.6641L71.3498 38.7206L71.2824 38.8664Z",
    fill: "#1F1F1F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5548 37.8237L62.4679 37.9585L71.2727 43.6377L71.3597 43.5029L62.5548 37.8237Z",
    fill: "#1F1F1F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2648 48.4085L62.46 41.1068L62.5626 40.9834L71.3674 48.2851L71.2648 48.4085Z",
    fill: "#1F1F1F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M58.189 53.4104L52.6196 44.2213V9.48209L52.6313 9.46288L58.189 0.292969V53.4104ZM52.7801 44.1766L58.0284 52.8361V0.867214L52.7801 9.52673V44.1766Z",
    fill: "#1F1F1F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9317 2.65479H56.7711V51.0486H56.9317V2.65479Z",
    fill: "#1F1F1F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8583 4.42578H55.6978V49.2775H55.8583V4.42578Z",
    fill: "#1F1F1F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9312 5.95508H54.7706V47.7481H54.9312V5.95508Z",
    fill: "#1F1F1F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1228 7.28955H53.9622V46.4143H54.1228V7.28955Z",
    fill: "#1F1F1F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M53.411 8.46338H53.2504V45.24H53.411V8.46338Z",
    fill: "#1F1F1F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0407 5.30666L52.6384 12.6133L52.7676 12.7089L58.1699 5.40224L58.0407 5.30666Z",
    fill: "#1F1F1F"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0509 10.0783L52.6414 15.7568L52.7574 15.8673L58.1668 10.1887L58.0509 10.0783Z",
    fill: "#1F1F1F"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0601 14.8454L52.6519 18.9028L52.7482 19.0313L58.1565 14.9739L58.0601 14.8454Z",
    fill: "#1F1F1F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0765 19.615L52.6661 22.0454L52.7319 22.1919L58.1423 19.7614L58.0765 19.615Z",
    fill: "#1F1F1F"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7114 25.3541L52.6879 25.1955L58.0968 24.3843L58.1203 24.5429L52.7114 25.3541Z",
    fill: "#1F1F1F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0968 29.319L52.6879 28.5078L52.7114 28.3491L58.1203 29.1603L58.0968 29.319Z",
    fill: "#1F1F1F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7326 31.5098L52.6667 31.6562L58.0756 34.09L58.1415 33.9435L52.7326 31.5098Z",
    fill: "#1F1F1F"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M52.748 34.6723L52.6516 34.8008L58.0605 38.8573L58.1569 38.7289L52.748 34.6723Z",
    fill: "#1F1F1F"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7576 37.8354L52.6417 37.9458L58.0506 43.6249L58.1665 43.5145L52.7576 37.8354Z",
    fill: "#1F1F1F"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7643 40.9971L52.6351 41.0928L58.044 48.3945L58.1732 48.2988L52.7643 40.9971Z",
    fill: "#1F1F1F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6294 53.7037L45.9529 44.1991L45.9561 9.48288L48.6294 0V53.7037ZM46.1135 44.188L48.4688 52.5432V1.16056L46.1135 9.51577V44.188Z",
    fill: "#1F1F1F"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0444 2.65479H47.8839V51.0486H48.0444V2.65479Z",
    fill: "#1F1F1F"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5451 4.42627H47.3845V49.278H47.5451V4.42627Z",
    fill: "#1F1F1F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1143 5.95508H46.9537V47.7481H47.1143V5.95508Z",
    fill: "#1F1F1F"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7382 7.28955H46.5776V46.4143H46.7382V7.28955Z",
    fill: "#1F1F1F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4072 8.46338H46.2466V45.24H46.4072V8.46338Z",
    fill: "#1F1F1F"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1092 12.6849L45.9572 12.6328L48.4731 5.33105L48.6251 5.38316L46.1092 12.6849Z",
    fill: "#1F1F1F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4781 10.1023L45.9574 15.7793L46.1039 15.8443L48.6246 10.1674L48.4781 10.1023Z",
    fill: "#1F1F1F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4812 14.8683L45.9645 18.9243L46.1009 19.0089L48.6175 14.9529L48.4812 14.8683Z",
    fill: "#1F1F1F"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4942 19.6297L45.9765 22.0615L46.0877 22.1767L48.6055 19.7449L48.4942 19.6297Z",
    fill: "#1F1F1F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5239 24.3864L46.0086 25.1992L46.058 25.352L48.5733 24.5392L48.5239 24.3864Z",
    fill: "#1F1F1F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0577 28.3526L46.0085 28.5054L48.5243 29.3166L48.5736 29.1638L46.0577 28.3526Z",
    fill: "#1F1F1F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0889 31.5256L45.9775 31.6406L48.4934 34.0744L48.6047 33.9594L46.0889 31.5256Z",
    fill: "#1F1F1F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1013 34.6947L45.965 34.7793L48.4808 38.8358L48.6171 38.7513L46.1013 34.6947Z",
    fill: "#1F1F1F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1063 37.8584L45.9598 37.9233L48.4756 43.6024L48.6222 43.5375L46.1063 37.8584Z",
    fill: "#1F1F1F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4731 48.3729L45.9572 41.0711L46.1092 41.019L48.6251 48.3208L48.4731 48.3729Z",
    fill: "#1F1F1F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechFigure2);
export default __webpack_public_path__ + "static/media/tech-figure-2.86cb51ac2071de330f5ce5891b67d3d2.svg";
export { ForwardRef as ReactComponent };